import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import AboutPage from "./pages/AboutPage";
import { Toaster } from "./components/ui/sonner";
import SmoothScrolling from "./components/SmoothScrolling";

function App() {
  return (
    <div className="App">
      <SmoothScrolling>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/about" element={<AboutPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </SmoothScrolling>
    </div>
  );
}

export default App;
